import * as l from "react";
import L from "react";
import Or from "@appchoose/cn";
import Me from "@appchoose/icon";
import "react-dom";
function $e(r, t) {
  if (typeof r == "function")
    return r(t);
  r != null && (r.current = t);
}
function Ye(...r) {
  return (t) => {
    let o = !1;
    const s = r.map((a) => {
      const u = $e(a, t);
      return !o && typeof u == "function" && (o = !0), u;
    });
    if (o)
      return () => {
        for (let a = 0; a < s.length; a++) {
          const u = s[a];
          typeof u == "function" ? u() : $e(r[a], null);
        }
      };
  };
}
function le(...r) {
  return l.useCallback(Ye(...r), r);
}
var H = { exports: {} }, B = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var We;
function Tr() {
  if (We) return B;
  We = 1;
  var r = L, t = Symbol.for("react.element"), o = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, a = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function v(c, f, p) {
    var m, g = {}, h = null, _ = null;
    p !== void 0 && (h = "" + p), f.key !== void 0 && (h = "" + f.key), f.ref !== void 0 && (_ = f.ref);
    for (m in f) s.call(f, m) && !u.hasOwnProperty(m) && (g[m] = f[m]);
    if (c && c.defaultProps) for (m in f = c.defaultProps, f) g[m] === void 0 && (g[m] = f[m]);
    return { $$typeof: t, type: c, key: h, ref: _, props: g, _owner: a.current };
  }
  return B.Fragment = o, B.jsx = v, B.jsxs = v, B;
}
var q = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Le;
function kr() {
  return Le || (Le = 1, process.env.NODE_ENV !== "production" && function() {
    var r = L, t = Symbol.for("react.element"), o = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), v = Symbol.for("react.provider"), c = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), k = Symbol.iterator, w = "@@iterator";
    function N(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = k && e[k] || e[w];
      return typeof n == "function" ? n : null;
    }
    var P = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(e) {
      {
        for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), d = 1; d < n; d++)
          i[d - 1] = arguments[d];
        re("error", e, i);
      }
    }
    function re(e, n, i) {
      {
        var d = P.ReactDebugCurrentFrame, E = d.getStackAddendum();
        E !== "" && (n += "%s", i = i.concat([E]));
        var R = i.map(function(y) {
          return String(y);
        });
        R.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, R);
      }
    }
    var j = !1, M = !1, Ge = !1, He = !1, Ze = !1, de;
    de = Symbol.for("react.module.reference");
    function Qe(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === s || e === u || Ze || e === a || e === p || e === m || He || e === _ || j || M || Ge || typeof e == "object" && e !== null && (e.$$typeof === h || e.$$typeof === g || e.$$typeof === v || e.$$typeof === c || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === de || e.getModuleId !== void 0));
    }
    function er(e, n, i) {
      var d = e.displayName;
      if (d)
        return d;
      var E = n.displayName || n.name || "";
      return E !== "" ? i + "(" + E + ")" : i;
    }
    function ve(e) {
      return e.displayName || "Context";
    }
    function D(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case s:
          return "Fragment";
        case o:
          return "Portal";
        case u:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case c:
            var n = e;
            return ve(n) + ".Consumer";
          case v:
            var i = e;
            return ve(i._context) + ".Provider";
          case f:
            return er(e, e.render, "ForwardRef");
          case g:
            var d = e.displayName || null;
            return d !== null ? d : D(e.type) || "Memo";
          case h: {
            var E = e, R = E._payload, y = E._init;
            try {
              return D(y(R));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, Y = 0, pe, me, he, be, ge, ye, Ee;
    function Re() {
    }
    Re.__reactDisabledLog = !0;
    function rr() {
      {
        if (Y === 0) {
          pe = console.log, me = console.info, he = console.warn, be = console.error, ge = console.group, ye = console.groupCollapsed, Ee = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Re,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        Y++;
      }
    }
    function tr() {
      {
        if (Y--, Y === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, e, {
              value: pe
            }),
            info: $({}, e, {
              value: me
            }),
            warn: $({}, e, {
              value: he
            }),
            error: $({}, e, {
              value: be
            }),
            group: $({}, e, {
              value: ge
            }),
            groupCollapsed: $({}, e, {
              value: ye
            }),
            groupEnd: $({}, e, {
              value: Ee
            })
          });
        }
        Y < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var te = P.ReactCurrentDispatcher, ne;
    function J(e, n, i) {
      {
        if (ne === void 0)
          try {
            throw Error();
          } catch (E) {
            var d = E.stack.trim().match(/\n( *(at )?)/);
            ne = d && d[1] || "";
          }
        return `
` + ne + e;
      }
    }
    var oe = !1, K;
    {
      var nr = typeof WeakMap == "function" ? WeakMap : Map;
      K = new nr();
    }
    function _e(e, n) {
      if (!e || oe)
        return "";
      {
        var i = K.get(e);
        if (i !== void 0)
          return i;
      }
      var d;
      oe = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var R;
      R = te.current, te.current = null, rr();
      try {
        if (n) {
          var y = function() {
            throw Error();
          };
          if (Object.defineProperty(y.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(y, []);
            } catch (T) {
              d = T;
            }
            Reflect.construct(e, [], y);
          } else {
            try {
              y.call();
            } catch (T) {
              d = T;
            }
            e.call(y.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (T) {
            d = T;
          }
          e();
        }
      } catch (T) {
        if (T && d && typeof T.stack == "string") {
          for (var b = T.stack.split(`
`), O = d.stack.split(`
`), C = b.length - 1, x = O.length - 1; C >= 1 && x >= 0 && b[C] !== O[x]; )
            x--;
          for (; C >= 1 && x >= 0; C--, x--)
            if (b[C] !== O[x]) {
              if (C !== 1 || x !== 1)
                do
                  if (C--, x--, x < 0 || b[C] !== O[x]) {
                    var A = `
` + b[C].replace(" at new ", " at ");
                    return e.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", e.displayName)), typeof e == "function" && K.set(e, A), A;
                  }
                while (C >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        oe = !1, te.current = R, tr(), Error.prepareStackTrace = E;
      }
      var V = e ? e.displayName || e.name : "", W = V ? J(V) : "";
      return typeof e == "function" && K.set(e, W), W;
    }
    function or(e, n, i) {
      return _e(e, !1);
    }
    function ar(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function X(e, n, i) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return _e(e, ar(e));
      if (typeof e == "string")
        return J(e);
      switch (e) {
        case p:
          return J("Suspense");
        case m:
          return J("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return or(e.render);
          case g:
            return X(e.type, n, i);
          case h: {
            var d = e, E = d._payload, R = d._init;
            try {
              return X(R(E), n, i);
            } catch {
            }
          }
        }
      return "";
    }
    var z = Object.prototype.hasOwnProperty, Ce = {}, xe = P.ReactDebugCurrentFrame;
    function G(e) {
      if (e) {
        var n = e._owner, i = X(e.type, e._source, n ? n.type : null);
        xe.setExtraStackFrame(i);
      } else
        xe.setExtraStackFrame(null);
    }
    function ir(e, n, i, d, E) {
      {
        var R = Function.call.bind(z);
        for (var y in e)
          if (R(e, y)) {
            var b = void 0;
            try {
              if (typeof e[y] != "function") {
                var O = Error((d || "React class") + ": " + i + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              b = e[y](n, y, d, i, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (C) {
              b = C;
            }
            b && !(b instanceof Error) && (G(E), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", d || "React class", i, y, typeof b), G(null)), b instanceof Error && !(b.message in Ce) && (Ce[b.message] = !0, G(E), S("Failed %s type: %s", i, b.message), G(null));
          }
      }
    }
    var sr = Array.isArray;
    function ae(e) {
      return sr(e);
    }
    function ur(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, i = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return i;
      }
    }
    function cr(e) {
      try {
        return Se(e), !1;
      } catch {
        return !0;
      }
    }
    function Se(e) {
      return "" + e;
    }
    function Pe(e) {
      if (cr(e))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ur(e)), Se(e);
    }
    var we = P.ReactCurrentOwner, lr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Oe, Te;
    function fr(e) {
      if (z.call(e, "ref")) {
        var n = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function dr(e) {
      if (z.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function vr(e, n) {
      typeof e.ref == "string" && we.current;
    }
    function pr(e, n) {
      {
        var i = function() {
          Oe || (Oe = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        i.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: i,
          configurable: !0
        });
      }
    }
    function mr(e, n) {
      {
        var i = function() {
          Te || (Te = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        i.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: i,
          configurable: !0
        });
      }
    }
    var hr = function(e, n, i, d, E, R, y) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: e,
        key: n,
        ref: i,
        props: y,
        // Record the component responsible for creating this element.
        _owner: R
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: d
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function br(e, n, i, d, E) {
      {
        var R, y = {}, b = null, O = null;
        i !== void 0 && (Pe(i), b = "" + i), dr(n) && (Pe(n.key), b = "" + n.key), fr(n) && (O = n.ref, vr(n, E));
        for (R in n)
          z.call(n, R) && !lr.hasOwnProperty(R) && (y[R] = n[R]);
        if (e && e.defaultProps) {
          var C = e.defaultProps;
          for (R in C)
            y[R] === void 0 && (y[R] = C[R]);
        }
        if (b || O) {
          var x = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          b && pr(y, x), O && mr(y, x);
        }
        return hr(e, b, O, E, d, we.current, y);
      }
    }
    var ie = P.ReactCurrentOwner, ke = P.ReactDebugCurrentFrame;
    function U(e) {
      if (e) {
        var n = e._owner, i = X(e.type, e._source, n ? n.type : null);
        ke.setExtraStackFrame(i);
      } else
        ke.setExtraStackFrame(null);
    }
    var se;
    se = !1;
    function ue(e) {
      return typeof e == "object" && e !== null && e.$$typeof === t;
    }
    function je() {
      {
        if (ie.current) {
          var e = D(ie.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function gr(e) {
      return "";
    }
    var Ae = {};
    function yr(e) {
      {
        var n = je();
        if (!n) {
          var i = typeof e == "string" ? e : e.displayName || e.name;
          i && (n = `

Check the top-level render call using <` + i + ">.");
        }
        return n;
      }
    }
    function Ne(e, n) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var i = yr(n);
        if (Ae[i])
          return;
        Ae[i] = !0;
        var d = "";
        e && e._owner && e._owner !== ie.current && (d = " It was passed a child from " + D(e._owner.type) + "."), U(e), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', i, d), U(null);
      }
    }
    function Ie(e, n) {
      {
        if (typeof e != "object")
          return;
        if (ae(e))
          for (var i = 0; i < e.length; i++) {
            var d = e[i];
            ue(d) && Ne(d, n);
          }
        else if (ue(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var E = N(e);
          if (typeof E == "function" && E !== e.entries)
            for (var R = E.call(e), y; !(y = R.next()).done; )
              ue(y.value) && Ne(y.value, n);
        }
      }
    }
    function Er(e) {
      {
        var n = e.type;
        if (n == null || typeof n == "string")
          return;
        var i;
        if (typeof n == "function")
          i = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === g))
          i = n.propTypes;
        else
          return;
        if (i) {
          var d = D(n);
          ir(i, e.props, "prop", d, e);
        } else if (n.PropTypes !== void 0 && !se) {
          se = !0;
          var E = D(n);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Rr(e) {
      {
        for (var n = Object.keys(e.props), i = 0; i < n.length; i++) {
          var d = n[i];
          if (d !== "children" && d !== "key") {
            U(e), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", d), U(null);
            break;
          }
        }
        e.ref !== null && (U(e), S("Invalid attribute `ref` supplied to `React.Fragment`."), U(null));
      }
    }
    var De = {};
    function Fe(e, n, i, d, E, R) {
      {
        var y = Qe(e);
        if (!y) {
          var b = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = gr();
          O ? b += O : b += je();
          var C;
          e === null ? C = "null" : ae(e) ? C = "array" : e !== void 0 && e.$$typeof === t ? (C = "<" + (D(e.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : C = typeof e, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", C, b);
        }
        var x = br(e, n, i, E, R);
        if (x == null)
          return x;
        if (y) {
          var A = n.children;
          if (A !== void 0)
            if (d)
              if (ae(A)) {
                for (var V = 0; V < A.length; V++)
                  Ie(A[V], e);
                Object.freeze && Object.freeze(A);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ie(A, e);
        }
        if (z.call(n, "key")) {
          var W = D(e), T = Object.keys(n).filter(function(wr) {
            return wr !== "key";
          }), ce = T.length > 0 ? "{key: someKey, " + T.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!De[W + ce]) {
            var Pr = T.length > 0 ? "{" + T.join(": ..., ") + ": ...}" : "{}";
            S(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ce, W, Pr, W), De[W + ce] = !0;
          }
        }
        return e === s ? Rr(x) : Er(x), x;
      }
    }
    function _r(e, n, i) {
      return Fe(e, n, i, !0);
    }
    function Cr(e, n, i) {
      return Fe(e, n, i, !1);
    }
    var xr = Cr, Sr = _r;
    q.Fragment = s, q.jsx = xr, q.jsxs = Sr;
  }()), q;
}
var Ue;
function jr() {
  return Ue || (Ue = 1, process.env.NODE_ENV === "production" ? H.exports = Tr() : H.exports = kr()), H.exports;
}
var I = jr();
function Ar(r, t = []) {
  let o = [];
  function s(u, v) {
    const c = l.createContext(v), f = o.length;
    o = [...o, v];
    const p = (g) => {
      var P;
      const { scope: h, children: _, ...k } = g, w = ((P = h == null ? void 0 : h[r]) == null ? void 0 : P[f]) || c, N = l.useMemo(() => k, Object.values(k));
      return /* @__PURE__ */ I.jsx(w.Provider, { value: N, children: _ });
    };
    p.displayName = u + "Provider";
    function m(g, h) {
      var w;
      const _ = ((w = h == null ? void 0 : h[r]) == null ? void 0 : w[f]) || c, k = l.useContext(_);
      if (k) return k;
      if (v !== void 0) return v;
      throw new Error(`\`${g}\` must be used within \`${u}\``);
    }
    return [p, m];
  }
  const a = () => {
    const u = o.map((v) => l.createContext(v));
    return function(c) {
      const f = (c == null ? void 0 : c[r]) || u;
      return l.useMemo(
        () => ({ [`__scope${r}`]: { ...c, [r]: f } }),
        [c, f]
      );
    };
  };
  return a.scopeName = r, [s, Nr(a, ...t)];
}
function Nr(...r) {
  const t = r[0];
  if (r.length === 1) return t;
  const o = () => {
    const s = r.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(u) {
      const v = s.reduce((c, { useScope: f, scopeName: p }) => {
        const g = f(u)[`__scope${p}`];
        return { ...c, ...g };
      }, {});
      return l.useMemo(() => ({ [`__scope${t.scopeName}`]: v }), [v]);
    };
  };
  return o.scopeName = t.scopeName, o;
}
function Ve(r, t, { checkForDefaultPrevented: o = !0 } = {}) {
  return function(a) {
    if (r == null || r(a), o === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
var Q = globalThis != null && globalThis.document ? l.useLayoutEffect : () => {
}, Ir = l[" useInsertionEffect ".trim().toString()] || Q;
function Dr({
  prop: r,
  defaultProp: t,
  onChange: o = () => {
  },
  caller: s
}) {
  const [a, u, v] = Fr({
    defaultProp: t,
    onChange: o
  }), c = r !== void 0, f = c ? r : a;
  {
    const m = l.useRef(r !== void 0);
    l.useEffect(() => {
      const g = m.current;
      g !== c && console.warn(
        `${s} is changing from ${g ? "controlled" : "uncontrolled"} to ${c ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), m.current = c;
    }, [c, s]);
  }
  const p = l.useCallback(
    (m) => {
      var g;
      if (c) {
        const h = Mr(m) ? m(r) : m;
        h !== r && ((g = v.current) == null || g.call(v, h));
      } else
        u(m);
    },
    [c, r, u, v]
  );
  return [f, p];
}
function Fr({
  defaultProp: r,
  onChange: t
}) {
  const [o, s] = l.useState(r), a = l.useRef(o), u = l.useRef(t);
  return Ir(() => {
    u.current = t;
  }, [t]), l.useEffect(() => {
    var v;
    a.current !== o && ((v = u.current) == null || v.call(u, o), a.current = o);
  }, [o, a]), [o, s, u];
}
function Mr(r) {
  return typeof r == "function";
}
function $r(r) {
  const t = l.useRef({ value: r, previous: r });
  return l.useMemo(() => (t.current.value !== r && (t.current.previous = t.current.value, t.current.value = r), t.current.previous), [r]);
}
function Wr(r) {
  const [t, o] = l.useState(void 0);
  return Q(() => {
    if (r) {
      o({ width: r.offsetWidth, height: r.offsetHeight });
      const s = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const u = a[0];
        let v, c;
        if ("borderBoxSize" in u) {
          const f = u.borderBoxSize, p = Array.isArray(f) ? f[0] : f;
          v = p.inlineSize, c = p.blockSize;
        } else
          v = r.offsetWidth, c = r.offsetHeight;
        o({ width: v, height: c });
      });
      return s.observe(r, { box: "border-box" }), () => s.unobserve(r);
    } else
      o(void 0);
  }, [r]), t;
}
function Lr(r, t) {
  return l.useReducer((o, s) => t[o][s] ?? o, r);
}
var ze = (r) => {
  const { present: t, children: o } = r, s = Ur(t), a = typeof o == "function" ? o({ present: s.isPresent }) : l.Children.only(o), u = le(s.ref, Vr(a));
  return typeof o == "function" || s.isPresent ? l.cloneElement(a, { ref: u }) : null;
};
ze.displayName = "Presence";
function Ur(r) {
  const [t, o] = l.useState(), s = l.useRef(null), a = l.useRef(r), u = l.useRef("none"), v = r ? "mounted" : "unmounted", [c, f] = Lr(v, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return l.useEffect(() => {
    const p = Z(s.current);
    u.current = c === "mounted" ? p : "none";
  }, [c]), Q(() => {
    const p = s.current, m = a.current;
    if (m !== r) {
      const h = u.current, _ = Z(p);
      r ? f("MOUNT") : _ === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && h !== _ ? "ANIMATION_OUT" : "UNMOUNT"), a.current = r;
    }
  }, [r, f]), Q(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, g = (_) => {
        const w = Z(s.current).includes(_.animationName);
        if (_.target === t && w && (f("ANIMATION_END"), !a.current)) {
          const N = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = N);
          });
        }
      }, h = (_) => {
        _.target === t && (u.current = Z(s.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", g), t.addEventListener("animationend", g), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", g), t.removeEventListener("animationend", g);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: l.useCallback((p) => {
      s.current = p ? getComputedStyle(p) : null, o(p);
    }, [])
  };
}
function Z(r) {
  return (r == null ? void 0 : r.animationName) || "none";
}
function Vr(r) {
  var s, a;
  let t = (s = Object.getOwnPropertyDescriptor(r.props, "ref")) == null ? void 0 : s.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? r.ref : (t = (a = Object.getOwnPropertyDescriptor(r, "ref")) == null ? void 0 : a.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? r.props.ref : r.props.ref || r.ref);
}
// @__NO_SIDE_EFFECTS__
function Yr(r) {
  const t = /* @__PURE__ */ zr(r), o = l.forwardRef((s, a) => {
    const { children: u, ...v } = s, c = l.Children.toArray(u), f = c.find(qr);
    if (f) {
      const p = f.props.children, m = c.map((g) => g === f ? l.Children.count(p) > 1 ? l.Children.only(null) : l.isValidElement(p) ? p.props.children : null : g);
      return /* @__PURE__ */ I.jsx(t, { ...v, ref: a, children: l.isValidElement(p) ? l.cloneElement(p, void 0, m) : null });
    }
    return /* @__PURE__ */ I.jsx(t, { ...v, ref: a, children: u });
  });
  return o.displayName = `${r}.Slot`, o;
}
// @__NO_SIDE_EFFECTS__
function zr(r) {
  const t = l.forwardRef((o, s) => {
    const { children: a, ...u } = o;
    if (l.isValidElement(a)) {
      const v = Kr(a), c = Jr(u, a.props);
      return a.type !== l.Fragment && (c.ref = s ? Ye(s, v) : v), l.cloneElement(a, c);
    }
    return l.Children.count(a) > 1 ? l.Children.only(null) : null;
  });
  return t.displayName = `${r}.SlotClone`, t;
}
var Br = Symbol("radix.slottable");
function qr(r) {
  return l.isValidElement(r) && typeof r.type == "function" && "__radixId" in r.type && r.type.__radixId === Br;
}
function Jr(r, t) {
  const o = { ...t };
  for (const s in t) {
    const a = r[s], u = t[s];
    /^on[A-Z]/.test(s) ? a && u ? o[s] = (...c) => {
      u(...c), a(...c);
    } : a && (o[s] = a) : s === "style" ? o[s] = { ...a, ...u } : s === "className" && (o[s] = [a, u].filter(Boolean).join(" "));
  }
  return { ...r, ...o };
}
function Kr(r) {
  var s, a;
  let t = (s = Object.getOwnPropertyDescriptor(r.props, "ref")) == null ? void 0 : s.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? r.ref : (t = (a = Object.getOwnPropertyDescriptor(r, "ref")) == null ? void 0 : a.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? r.props.ref : r.props.ref || r.ref);
}
var Xr = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], fe = Xr.reduce((r, t) => {
  const o = /* @__PURE__ */ Yr(`Primitive.${t}`), s = l.forwardRef((a, u) => {
    const { asChild: v, ...c } = a, f = v ? o : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ I.jsx(f, { ...c, ref: u });
  });
  return s.displayName = `Primitive.${t}`, { ...r, [t]: s };
}, {}), ee = "Checkbox", [Gr, st] = Ar(ee), [Hr, Zr] = Gr(ee), Be = l.forwardRef(
  (r, t) => {
    const {
      __scopeCheckbox: o,
      name: s,
      checked: a,
      defaultChecked: u,
      required: v,
      disabled: c,
      value: f = "on",
      onCheckedChange: p,
      form: m,
      ...g
    } = r, [h, _] = l.useState(null), k = le(t, (j) => _(j)), w = l.useRef(!1), N = h ? m || !!h.closest("form") : !0, [P, S] = Dr({
      prop: a,
      defaultProp: u ?? !1,
      onChange: p,
      caller: ee
    }), re = l.useRef(P);
    return l.useEffect(() => {
      const j = h == null ? void 0 : h.form;
      if (j) {
        const M = () => S(re.current);
        return j.addEventListener("reset", M), () => j.removeEventListener("reset", M);
      }
    }, [h, S]), /* @__PURE__ */ I.jsxs(Hr, { scope: o, state: P, disabled: c, children: [
      /* @__PURE__ */ I.jsx(
        fe.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": F(P) ? "mixed" : P,
          "aria-required": v,
          "data-state": Xe(P),
          "data-disabled": c ? "" : void 0,
          disabled: c,
          value: f,
          ...g,
          ref: k,
          onKeyDown: Ve(r.onKeyDown, (j) => {
            j.key === "Enter" && j.preventDefault();
          }),
          onClick: Ve(r.onClick, (j) => {
            S((M) => F(M) ? !0 : !M), N && (w.current = j.isPropagationStopped(), w.current || j.stopPropagation());
          })
        }
      ),
      N && /* @__PURE__ */ I.jsx(
        Ke,
        {
          control: h,
          bubbles: !w.current,
          name: s,
          value: f,
          checked: P,
          required: v,
          disabled: c,
          form: m,
          style: { transform: "translateX(-100%)" },
          defaultChecked: F(u) ? !1 : u
        }
      )
    ] });
  }
);
Be.displayName = ee;
var qe = "CheckboxIndicator", Je = l.forwardRef(
  (r, t) => {
    const { __scopeCheckbox: o, forceMount: s, ...a } = r, u = Zr(qe, o);
    return /* @__PURE__ */ I.jsx(ze, { present: s || F(u.state) || u.state === !0, children: /* @__PURE__ */ I.jsx(
      fe.span,
      {
        "data-state": Xe(u.state),
        "data-disabled": u.disabled ? "" : void 0,
        ...a,
        ref: t,
        style: { pointerEvents: "none", ...r.style }
      }
    ) });
  }
);
Je.displayName = qe;
var Qr = "CheckboxBubbleInput", Ke = l.forwardRef(
  ({
    __scopeCheckbox: r,
    control: t,
    checked: o,
    bubbles: s = !0,
    defaultChecked: a,
    ...u
  }, v) => {
    const c = l.useRef(null), f = le(c, v), p = $r(o), m = Wr(t);
    l.useEffect(() => {
      const h = c.current;
      if (!h) return;
      const _ = window.HTMLInputElement.prototype, w = Object.getOwnPropertyDescriptor(
        _,
        "checked"
      ).set;
      if (p !== o && w) {
        const N = new Event("click", { bubbles: s });
        h.indeterminate = F(o), w.call(h, F(o) ? !1 : o), h.dispatchEvent(N);
      }
    }, [p, o, s]);
    const g = l.useRef(F(o) ? !1 : o);
    return /* @__PURE__ */ I.jsx(
      fe.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: a ?? g.current,
        ...u,
        tabIndex: -1,
        ref: f,
        style: {
          ...u.style,
          ...m,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Ke.displayName = Qr;
function F(r) {
  return r === "indeterminate";
}
function Xe(r) {
  return F(r) ? "indeterminate" : r ? "checked" : "unchecked";
}
var et = Be, rt = Je;
const tt = L.forwardRef(({ className: r, ...t }, o) => /* @__PURE__ */ L.createElement(
  et,
  {
    ref: o,
    className: Or(
      "peer flex size-5 cursor-pointer items-center justify-center rounded-[2px] border-[1px] border-gray-600 text-green-900 outline-0 transition duration-300 focus:ring-2 focus:ring-gray-900/30 disabled:cursor-not-allowed disabled:border-gray-300 disabled:text-gray-300 data-[state=checked]:border-green-900 data-[state=indeterminate]:border-green-900 data-[state=checked]:bg-green-900 data-[state=indeterminate]:bg-green-900 data-[state=checked]:focus:ring-2 data-[state=indeterminate]:focus:ring-2 data-[state=checked]:focus:ring-green-900/30 data-[state=indeterminate]:focus:ring-green-900/30 data-[state=checked]:disabled:border-gray-300 data-[state=indeterminate]:disabled:border-gray-300 data-[state=checked]:disabled:bg-gray-300 data-[state=indeterminate]:disabled:bg-gray-300",
      r
    ),
    ...t
  },
  /* @__PURE__ */ L.createElement(rt, null, (t.defaultChecked ?? t.checked) === "indeterminate" ? /* @__PURE__ */ L.createElement(Me, { className: "size-[14px] text-white", icon: "minus", size: "small" }) : null, (t.defaultChecked ?? t.checked) === !0 ? /* @__PURE__ */ L.createElement(Me, { className: "size-[14px] text-white", icon: "check", size: "small" }) : null)
));
tt.displayName = "Checkbox";
export {
  tt as Checkbox,
  tt as default
};
